import { colors } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const WrapperStyled = styled.div`
  background-color: ${colors.neutral.white};
  border-radius: 10px;
  padding: 5rem;
  box-sizing: border-box;
  position: relative;
  margin: 0 auto;
  min-height: 24rem;
`;
